import _ from 'lodash';
import {createSelector} from 'reselect';
import {TRASH_FOLDER} from './consts';

/**
 * This entire file doesn't contain a single example of properly designed/working selector
 * DON'T USE THIS AS AN EXAMPLE!! (ask michael)
 */

export const getImagesObj = state => state.images.Images;

const getImageObj = (state, type) => state.images[type];

function pickNamesList(folders, {currentPath = '', separator = '\\'}) {
  let acc = [];
  if (_.size(folders) > 0) {
    _.forEach(folders, folder => {
      const curFolderName = currentPath.length ? `${currentPath}${separator}${folder.name}` : folder.name;
      acc.push(curFolderName);
      if (folder.folders) {
        acc = _.union(acc, pickNamesList(folder.folders, {separator, currentPath: curFolderName}));
      }
    });
    return _.orderBy(acc, item => item.toLowerCase().trim());
  }
  return [];
}

export const getFolderListNames = createSelector(
  getImageObj,
  images => pickNamesList(images.folders, {})
);

const imageDecorate = (files, folderData) =>
  _.map(files, file => ({
    ...file,
    path: folderData.path,
    url: folderData.url + encodeURIComponent(file.name),
  }));

export const getCurrentFolderImages = createSelector(
  [
    (state, props) => getImageObj(state, props.resourceType),
    (state, props) => props.currentFolder,
    (state, props) => props.resourceType,
  ],
  (images, folderName, resourceType) => {
    if (folderName) {
      const folderPath = folderName.split('\\');
      const curFolder = folderPath.reduce((obj, folderName) => {
        if (obj && _.has(obj.folders, folderName)) {
          return obj.folders[folderName];
        }
        return false;
      }, images);
      if (curFolder) {
        return imageDecorate(curFolder.files, curFolder.currentFolder);
      }
      return [];
    }
    if (resourceType === 'Icons') {
      const firstFolderName = _.findKey(images.folders, item => item);
      return images.folders
        ? imageDecorate(images.folders[firstFolderName].files, images.folders[firstFolderName].currentFolder)
        : [];
    }
    return images.files ? imageDecorate(images.files, images.currentFolder) : [];
  }
);

export const getSelectedImages = createSelector(
  state => getImagesObj(state, 'Images'),
  images => images.selectedImages
);

export const getRouteQuery = state => state.routing.location.query;

export const isDialogActive = (state, dialogName) => {
  return getRouteQuery(state).dialogName === dialogName;
};

export const createFilePathObject = image => {
  const imageSplited = _.split(image, '/');
  return {
    fileName: _.last(imageSplited),
    path: `${_.join(_.dropRight(imageSplited), '/')}/`,
  };
};

export const getSelectedImage = createSelector(
  getSelectedImages,
  selectedImages => {
    return createFilePathObject(_.keys(selectedImages)[0]);
  }
);

export const isTrashFolder = currentFolder => currentFolder === TRASH_FOLDER;

export const getUploadedFiles = (state, props) => {
  const imageObj = getImageObj(state, props.resourceType);
  return imageObj ? imageObj.uploadFiles : [];
};
